import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-feedback', 'MIN_RATE', 'Difficult');
Labels.set('ui-feedback', 'MAX_RATE', 'Easy');
Labels.set('ui-feedback', 'POSITIVE', 'Yes');
Labels.set('ui-feedback', 'NEGATIVE', 'No');
Labels.set('ui-feedback', 'CONFIRM', 'Send');
Labels.set('ui-feedback', 'CANCEL', 'Cancel');
Labels.set(
    'ui-feedback',
    'TEXTAREA_LABEL',
    'What can we do to make this even better?'
);
Labels.set(
    'ui-feedback',
    'HINT_MESSAGE',
    'This feedback is anonymous. We will use it to improve our services.'
);
Labels.set('ui-feedback', 'SUCCESS_MESSAGE', 'Thank you for your feedback!');
Labels.set('ui-feedback', 'ERROR_MESSAGE', 'Feedback sending failed');
